module.exports = __webpack_public_path__ + "img/icon2.a2840ebb.png";